<div class="outer-content">
    <div class="container">
        <p class="header">Enter Your Personal Address</p>
        <profile-details #profileDetailRef (profileData)="receiveProfileData($event)"></profile-details>
        <app-address #addressDetailRef (addressData)="receiveAddressData($event)"></app-address>
        <div class="btn-content">
            <app-button variant="hero" (onClick)="submitForm()" [disabled]="!isFormDataValid()">{{
                "userDetails.button.save&ContinueBtn" | translate
            }}</app-button>
        </div>
        <br />
    </div>
</div>
